<script setup lang="ts">
  import { stringDateToHHMM } from '@/utils/date.utils';
  import { computed } from 'vue';

  const props = defineProps<{
    date: string | Date;
    hideAgo?: boolean;
  }>();

  const hhMM = computed(() => stringDateToHHMM(props.date));
</script>

<template>
  <div class="complete-time">
    <span class="time--hhmm">{{ hhMM }}</span>
    <timeago
      v-if="!hideAgo"
      class="time--ago"
      :datetime="date"
      :auto-update="60"
    ></timeago>
  </div>
</template>

<style scoped lang="scss">
  .complete-time {
    @apply tw-flex tw-items-center tw-space-x-1;

    .time--hhmm {
      @apply tw-text-xs tw-font-semibold tw-text-gray-500;
    }

    .time--ago {
      @apply tw-text-xs tw-text-gray-500;
    }
  }
</style>
